"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Days = exports.OrderChannel = exports.OrderMode = void 0;
var OrderMode;
(function (OrderMode) {
    OrderMode["DELIVERY"] = "DELIVERY";
    OrderMode["TAKEAWAY"] = "TAKEAWAY";
    OrderMode["ONSPOT"] = "ONSPOT";
})(OrderMode || (exports.OrderMode = OrderMode = {}));
var OrderChannel;
(function (OrderChannel) {
    OrderChannel["WEBSITE"] = "website";
    OrderChannel["TICKEAT_OS"] = "tickeat_os";
    OrderChannel["UBER_EATS"] = "uber_eats";
    OrderChannel["JUST_EAT"] = "just_eat";
    OrderChannel["DELIVEROO"] = "deliveroo";
    OrderChannel["DELICITY"] = "delicity";
    OrderChannel["KIOSK"] = "kiosk";
    OrderChannel["TABLE"] = "table";
})(OrderChannel || (exports.OrderChannel = OrderChannel = {}));
var Days;
(function (Days) {
    Days["MONDAY"] = "monday";
    Days["TUESDAY"] = "tuesday";
    Days["WEDNESDAY"] = "wednesday";
    Days["THURSDAY"] = "thursday";
    Days["FRIDAY"] = "friday";
    Days["SATURDAY"] = "saturday";
    Days["SUNDAY"] = "sunday";
})(Days || (exports.Days = Days = {}));
